export enum ManagementTabType {
  PendingApproval = 1,
  PendingExceptionsCommitteeApproval = 2,
  CompletionReturned = 3,
  Approved = 4,
  PendingExecution = 5,
  Archive = 6,
}
